import {FC} from "react";
import {ModalFooter} from "../../../layout/ModalProvider";
import {TeamSpaceItem} from "../../../../api/repositories/documentation-library-repository";
import {useApiCall} from "../../../../api";
import {config} from "@jane/frontend-medewerker/src/config";
import {ConfigInterface} from "../../../../config";

export const SetDefaultTeamSpacePageModal: FC<{ page: TeamSpaceItem, onSpacesUpdated: () => void, getPages: (teamSpaceId: string) => void, config: ConfigInterface }> = (props) => {
  const { documentations } = useApiCall(config)

  const save = async () => {
    await documentations.setDefaultPage(props.page.id)
      .then(async () => {
        await props.onSpacesUpdated();
        await props.getPages(props.page.teamSpaceId);
      })
      .catch((error) => {
        console.error('Failed to save default page:', error);
      });
  }

  return <>
    <div>
      <strong>Let op!</strong> weet je zeker dat je deze pagina als hoofdpagina in wilt stellen?
    </div>
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </>
}